import gql from 'graphql-tag'

import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'

const mutation = gql`
  mutation starRecipes($recipes: [ID!]!) {
    starRecipes(recipes: $recipes) {
      favorite_recipes {
        id
      }
    }
  }
`

const transformer = ({ starRecipes }: any) => starRecipes.favorite_recipes

type variables = {
  recipes: string[]
}

export default mutationServiceCreator<variables>(mutation, transformer)
